<script setup lang="ts">
import Modal from '~common/modal.vue'
import { useModal } from '~/composables/common/use-modal'
import { AccountTabs } from '~/constants/account.ts'
import { ModalCollection, PROMOTION_SLUG_BY_TYPE } from '~/constants'
const { closeModal } = useModal()
</script>

<template>
  <Modal
    :modalId="ModalCollection.FIVEH_K_PROMOTION"
    isShowIconClose
    modalDialogClasses="modal-500k"
    modalContentClasses="modal-500k__content"
    modalBodyClasses="p-0"
  >
    <NuxtLink
      :to="`${AccountTabs.PROMOTION}?tab=${PROMOTION_SLUG_BY_TYPE.EVENT_500K}`"
      @click="closeModal(ModalCollection.FIVEH_K_PROMOTION)"
    >
      <NuxtImg
        src="/assets/images/components/banners/popup-500k.webp"
        densities="1px 2px"
        alt="500k banner"
      />
    </NuxtLink>
  </Modal>
</template>

<style lang="scss">
@import '~scssAsset/components/common/modal-500k.scss';
</style>
